import classnames from 'clsx'
import propTypes from 'prop-types'

import TextWithIcon from 'views/components/molecules/TextWithIcon'
import withDataQA from 'views/enhancers/withDataQA'

const LinkWithIcon = props => (
  <a
    href={props.href}
    data-qa-id={props.qaId ? `${props.qaId}-link` : null}
    target={props.target === '_blank' ? props.target : null}
    rel={props.target === '_blank' ? 'noopener noreferrer' : null}
    className={classnames('a-link--underline', props.className)}
    data-clientside-hook={props['data-clientside-hook']}
    id={props.id}
    onClick={props.onClick}
  >
    <TextWithIcon
      icon={props.icon}
      centered={props.centered}
      inline={props.inline}
      right={props.right}
      qaId={props.qaId}
    >
      {props.children}
    </TextWithIcon>
  </a>
)

LinkWithIcon.propTypes = {
  icon: propTypes.node.isRequired,
  centered: propTypes.bool,
  inline: propTypes.bool,
  right: propTypes.bool,
  href: propTypes.string.isRequired,
  children: propTypes.node.isRequired,
  target: propTypes.string,
  className: propTypes.string,
  qaId: propTypes.string,
  'data-clientside-hook': propTypes.string,
  id: propTypes.string,
  onClick: propTypes.func,
}

LinkWithIcon.defaultProps = {
  centered: false,
  inline: false,
  right: false,
  target: null,
  className: null,
  qaId: null,
  id: null,
  'data-clientside-hook': undefined,
}

export default withDataQA(LinkWithIcon)
